import { GrApple } from "@onemind-services-llc/react-icons-ng/gr";
import { MdWidgets, MdPhoneInTalk } from "@onemind-services-llc/react-icons-ng/md";
import HostedElastic from "public/application-services/icons/hosted-elastic.png";
import HostedGrafana from "public/application-services/icons/hosted-grafana.png";
import HostedNetbox from "public/application-services/icons/hosted-netbox.png";
import HostedOpenText from "public/application-services/icons/hosted-open-text.png";
import HostedPBX from "public/application-services/icons/hosted-pbx.png";
import Inuvika from "public/application-services/icons/inuvika.png";
import Rancher from "public/application-services/icons/rancher.png";
import WhiteHostedElastic from "public/application-services/whiteIcons/hosted-elastic.png";
import WhiteHostedGrafana from "public/application-services/whiteIcons/hosted-grafana.png";
import WhiteHostedNetbox from "public/application-services/whiteIcons/hosted-netbox.png";
import WhiteHostedOpenText from "public/application-services/whiteIcons/hosted-open-text.png";
import WhiteHostedPBX from "public/application-services/whiteIcons/hosted-pbx.png";
import WhiteHostedRancher from "public/application-services/whiteIcons/hosted-rancher.png";
import WhiteInuvika from "public/application-services/whiteIcons/inuvika.png";
import { MAIN_ROUTES, APPS_ROUTES } from "@/constants/routes";
import { ContentWithTextAndLink } from "@/components/contentCard/contentWithText";

export const SERVICES_CONSTANTS = {
  title: "Our Cloud Application Services",
  list: [
    {
      image: HostedElastic,
      whiteImage: WhiteHostedElastic,
      title: "Hosted Elastic Stack Licensed",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_ELASTIC}`}
          text="Leverage the power of Elasticsearch, Logstash, and Kibana (ELK Stack) in a secure, cloud-hosted environment. Gain actionable insights, streamline log management, and enhance search capabilities without managing complex infrastructure."
        />
      ),
    },
    {
      image: HostedGrafana,
      whiteImage: WhiteHostedGrafana,
      title: "Hosted Grafana",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_GRAFANA}`}
          text="Transform data visualization with Grafana, hosted and managed by OneMind Services. Monitor key metrics, analyze performance, and create intuitive dashboards without worrying about infrastructure maintenance."
        />
      ),
    },
    {
      image: HostedOpenText,
      whiteImage: WhiteHostedOpenText,
      title: "Hosted Open-Text NOM",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_NOM}`}
          text="Optimize your network and IT infrastructure with Open-Text Network Operations Management (NOM). Our hosted solution ensures real-time network monitoring, analytics, and automation to enhance performance and uptime."
        />
      ),
    },
    {
      image: HostedPBX,
      whiteImage: WhiteHostedPBX,
      title: "Hosted Yeastar PBX",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_PBX}`}
          text="Enhance business communication with a cloud-based PBX system. Our hosted PBX solutions offer high-quality voice communication, scalability, and integration with modern collaboration tools, ensuring seamless operations for remote and hybrid teams."
        />
      ),
    },

    {
      image: HostedNetbox,
      whiteImage: WhiteHostedNetbox,
      title: "Hosted Netbox (IPAM/DCIM )",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_NETBOX}`}
          text="Simplify IT asset management with Netbox, a powerful infrastructure resource modeling tool. Our cloud-hosted Netbox services provide enhanced security, accessibility, and automation capabilities for IT teams."
        />
      ),
    },
    {
      image: Rancher,
      whiteImage: WhiteHostedRancher,
      title: "Hosted Rancher (k8s Management)",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_RANCHER}`}
          text="Manage and deploy Kubernetes clusters seamlessly with Rancher, hosted in a secure cloud environment. Our managed Rancher services ensure smooth container orchestration, reducing operational complexities."
        />
      ),
    },
    {
      // image: HostedCMS,
      // whiteImage: WhiteHostedCMS,
      icon: GrApple,
      iconWithCircle: false,
      title: "Hosted Mac ",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_MAC}`}
          text="Deliver macOS desktops in the cloud for developers, testers, and creatives. OneMind’s Hosted Mac service provides instant access to macOS environments via Splashtop—ideal for Xcode, Final Cut Pro, and cross-platform QA workflows without buying physical Mac hardware."
        />
      ),
    },
    {
      image: Inuvika,
      whiteImage: WhiteInuvika,
      title: "Inuvika VDI Platform",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.INUVIKA_VDI}`}
          text="Empower your workforce with a cloud-hosted Virtual Desktop Infrastructure (VDI). The Inuvika VDI platform ensures secure remote access, optimized performance, and cost efficiency for modern workplaces."
        />
      ),
    },
    {
      icon: MdPhoneInTalk,
      iconWithCircle: false,
      title: "3CX phone system",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.CX3_PHONESYSTEM}`}
          text="Simplify business communications with a secure, software-based PBX hosted by OneMind. Our hosted 3CX solution delivers encrypted SIP-based telephony, hybrid hardware integration, and scalable VoIP services for growing teams—without the complexity of managing on-premise systems."
        />
      ),
    },
    {
      icon: MdWidgets,
      iconWithCircle: false,
      title: "Marketplace Apps",
      content: (
        <ContentWithTextAndLink
          link={`${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.MARKETPLACE_APPS}`}
          text="Discover, deploy, and scale with OneMind AppSpace — a marketplace of open-source and enterprise-ready applications. From databases to monitoring, security, and developer tools, AppSpace empowers teams with pre-integrated apps for a modern cloud-native stack."
        />
      ),
    },
  ],
};
